import React, { useEffect } from "react";
import { useState } from "react";
import getAxiosInstance from "./../../Utils/axios";

function RecentUpdates() {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    getAxiosInstance()
      .get("/admin/get-updates")
      .then((res) => {
        console.log(res.data);
        setUpdates(res.data.result);
        console.log({ updates });
      })
      .catch((err) => console.log(err));
  }, []);

  // console.log({ updates });
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-sm-6">
                <h1 className="m-0">Updates</h1>
              </div>
              <div className="col-sm-6">
                <button
                  type="button"
                  className="btn btn-dark float-right"
                  onClick={(e) => {
                    window.location.href = "/add-updates";
                  }}
                >
                  Add New Update
                </button>
              </div>
            </div>

            <div className="row justify-content-center mt-3">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 80 }}>SL No.</th>
                          <th>Update</th>
                          <th>Download Link</th>
                          {/* <th>Code</th>
                          <th>Contact Number</th>
                          <th>Locations assigned</th>
                          <th></th> */}
                          <th style={{ width: 40 }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {isLoading && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={8}>Loading Users ...</td>
                          </tr>
                        )} */}
                        {/* {!isLoading && totalUsers === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={8}>No Users Found</td>
                          </tr>
                        )} */}
                        {updates?.map((update, i) => (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>{update.version}</td>
                            <td>{update.link}</td>

                            {/* <td>
                              <div style={{ display: "flex" }}>
                                <button
                                  type="button"
                                  class="btn btn-success btn-sm ml-1"
                                  onClick={() => {
                                    window.location.href =
                                      "/edit-updates/" + updates._id;
                                  }}
                                  title="Edit"
                                >
                                  <i className="fas fa-pen"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-danger btn-sm ml-1"
                                  title="Delete"
                                  onClick={() => deleteUser(user._id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                                {user.active === 1 ? (
                                  <button
                                    type="button"
                                    class="btn btn-danger btn-sm ml-1"
                                    title="Deactivate"
                                    onClick={() => userStatus(user._id, 0)}
                                  >
                                    <i className="fas fa-lock"></i>
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="btn btn-success btn-sm ml-1"
                                    title="Activate"
                                    onClick={() => userStatus(user._id, 1)}
                                  >
                                    <i className="fas fa-unlock"></i>
                                  </button>
                                )}
                              </div>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer clearfix">
                    {/* {totalUsers > limit ? (
                      <ReactPaginate
                        previousLabel={"«"}
                        nextLabel={"»"}
                        pageCount={Math.ceil(totalUsers / limit)}
                        onPageChange={changePage}
                        containerClassName={
                          "pagination pagination-sm m-0 float-right"
                        }
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        // previousClassName={"previous"}
                        previousLinkClassName={"page-link"}
                        // nextClassName={"next"}
                        nextLinkClassName={"page-link"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                      />
                    ) : null} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentUpdates;
